var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8349 15.1323C22.5154 15.2647 22.229 15.5511 21.6562 16.1239C21.0835 16.6965 20.797 16.9831 20.6646 17.3025C20.4882 17.7285 20.4882 18.2072 20.6646 18.6332C20.797 18.9527 21.0834 19.2391 21.6562 19.8119C22.2287 20.3844 22.5154 20.6712 22.8348 20.8035C23.2608 20.9799 23.7395 20.9799 24.1655 20.8035C24.485 20.6711 24.7714 20.3847 25.3442 19.8119C25.917 19.2391 26.2026 18.9527 26.3349 18.6332C26.5114 18.2072 26.5114 17.7285 26.3349 17.3025C26.2026 16.983 25.917 16.6967 25.3442 16.1239C24.7714 15.5511 24.485 15.2647 24.1655 15.1323C23.7395 14.9559 23.2609 14.9559 22.8349 15.1323Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3026 20.6642C16.9831 20.7966 16.6967 21.083 16.1239 21.6558C15.5512 22.2284 15.2647 22.515 15.1323 22.8344C14.9559 23.2604 14.9559 23.7391 15.1323 24.1651C15.2647 24.4846 15.5511 24.771 16.1239 25.3438C16.6964 25.9163 16.9831 26.2031 17.3025 26.3354C17.7285 26.5118 18.2072 26.5118 18.6332 26.3354C18.9527 26.203 19.2391 25.9166 19.8119 25.3438C20.3847 24.771 20.6703 24.4846 20.8026 24.1651C20.9791 23.7391 20.9791 23.2604 20.8026 22.8344C20.6703 22.5149 20.3847 22.2286 19.8119 21.6558C19.2391 21.083 18.9527 20.7966 18.6332 20.6642C18.2072 20.4878 17.7286 20.4878 17.3026 20.6642Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1885 21.6558C26.6158 22.2284 26.3293 22.515 26.197 22.8344C26.0205 23.2604 26.0205 23.7391 26.197 24.1651C26.3293 24.4846 26.6157 24.771 27.1885 25.3438C27.761 25.9163 28.0477 26.2031 28.3672 26.3354C28.7931 26.5118 29.2718 26.5118 29.6978 26.3354C30.0173 26.203 30.3037 25.9166 30.8765 25.3438C31.4493 24.771 31.7349 24.4846 31.8672 24.1651C32.0437 23.7391 32.0437 23.2604 31.8672 22.8344C31.7349 22.5149 31.4493 22.2286 30.8765 21.6558C30.3037 21.083 30.0173 20.7966 29.6978 20.6642C29.2718 20.4878 28.7932 20.4878 28.3672 20.6642C28.0477 20.7966 27.7613 21.083 27.1885 21.6558Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8349 26.1965C22.5154 26.3289 22.229 26.6153 21.6562 27.1881C21.0835 27.7607 20.797 28.0473 20.6646 28.3667C20.4882 28.7927 20.4882 29.2714 20.6646 29.6974C20.797 30.0169 21.0834 30.3033 21.6562 30.8761C22.2287 31.4486 22.5154 31.7354 22.8348 31.8677C23.2608 32.0441 23.7395 32.0441 24.1655 31.8677C24.485 31.7353 24.7714 31.4489 25.3442 30.8761C25.917 30.3033 26.2026 30.0169 26.3349 29.6974C26.5114 29.2714 26.5114 28.7927 26.3349 28.3667C26.2026 28.0472 25.917 27.7609 25.3442 27.1881C24.7714 26.6153 24.485 26.3289 24.1655 26.1965C23.7395 26.0201 23.2609 26.0201 22.8349 26.1965Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions.d227eb0507ba5f100c96518d6b6fcd83.svg";
export { ForwardRef as ReactComponent };